import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

import s from './SystemMessage.css';
import {
  ADDED_USER_TO_CHANNEL,
  BEGINNING_OF_CHANNEL,
  USER_JOINED_CHANNEL
} from '../../constants/AppConstants';
import {USER_LEFT_CHANNEL} from '../../constants/ActionTypes';
import {isChannel} from "../../helpers/ChatUtils";

const SystemMessage = ({ message: { id, content, timeSent }, users, chat, isSelectingMessages }) => {
  const systemMessageData = JSON.parse(content);
  if (!systemMessageData) {
    return null;
  }
  const { initiatorId, inviteeIds, type } = systemMessageData;
  const displayTime = moment(timeSent).format('h:mm a');

  let systemMessageDisplay = '';
  const initiatorName = initiatorId && users[initiatorId] && `${users[initiatorId].firstName} ${users[initiatorId].lastName}`;

  switch(type) {
    case ADDED_USER_TO_CHANNEL:
      const allInviteesByName = inviteeIds && inviteeIds.map(id => users[id] && `${users[id].firstName} ${users[id].lastName}`);
      const invitees = inviteeIds && inviteeIds.length ? (
        // remove last user from array and join each of those with a comma,
        // then get the last user from the original array and add 'and' to string
        // (assuming there are multiple users)
        [allInviteesByName.slice(0, -1).join(', '), allInviteesByName.slice(-1)[0]].join(allInviteesByName.length < 2 ? '' : ' and ')
      ) : 'User';

      systemMessageDisplay = `${invitees} ${inviteeIds.length > 1 ? 'were' : 'was'} added to the chat by ${initiatorName} at ${displayTime}.`;
      break;
    case USER_JOINED_CHANNEL:
      systemMessageDisplay = `${initiatorName} joined the chat at ${displayTime}.`;
      break;
    case USER_LEFT_CHANNEL:
      systemMessageDisplay = `${initiatorName} left the chat at ${displayTime}.`;
      break;
    case BEGINNING_OF_CHANNEL:
      systemMessageDisplay = isChannel(chat)
        ? <span>This is the beginning of the  <strong>{chat.name}</strong> channel history.</span>
        : 'This is the beginning of the chat history.' ;
      break;
    default:
      //If there is no message we don't want to render an empty system message
      return null;
  }

  return (
    <div
      id={`message-${id}`}
      className={classnames({
        [s.systemMessage]: true,
        [s.inSelectionMode]: isSelectingMessages
      })}
      data-qa={`message`}
    >
      <div className={s.messageContainer}>
        <span className={s.messageContent}>
          {systemMessageDisplay}
        </span>
      </div>
    </div>
  );
};

SystemMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
    timeSent: PropTypes.string.isRequired
  }),
  users: PropTypes.object,
  chat: PropTypes.shape({
    id: PropTypes.number,
    users: PropTypes.array,
    name: PropTypes.string,
    type: PropTypes.string,
  }),
  isSelectingMessages: PropTypes.bool
};


export default SystemMessage;
